import { ofType } from 'redux-observable';
import { filter, map } from 'rxjs/operators';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import { commonFormActions } from 'state/forms/actions/form';

export function fillTabContentInEssentialScreenFailedEpic(): SpEpic {
  return action$ =>
    action$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCH_FAILED'),
      filter(({ workspace }) => workspace === 'essential'),
      map(({ tabId }) => {
        return commonFormActions.formReloadFailed('essential', tabId);
      }),
    );
}
